import {mainState as ms} from '../../initData'

export function serverError(e) {
   console.log('serverError: ', e)
   
   ms.preloader(0)
}